import { Box, Grid } from '@mui/material';

import SettingsHeader from '../../components/SettingsHeader/SettingsHeader';

import UserProfileIndex from './components/userProfileIndex/UserProfileIndex';

interface IJobBoard {
  children: React.ReactElement;
  title?: string;
}

const RecruiterProfileDetails = ({ children, title }: IJobBoard) => (
  <Box>
    <SettingsHeader title={title ? title : 'User Profile'} />
    <Grid container rowGap={3}>
      {!title && (
        <Grid item xs={3}>
          <UserProfileIndex />
        </Grid>
      )}
      <Grid item xs={9} pt={3}>
        {children}
      </Grid>
    </Grid>
  </Box>
);
export default RecruiterProfileDetails;
